import script from "./DefModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefModal.vue?vue&type=script&lang=ts&setup=true"

import "./DefModal.vue?vue&type=style&index=0&id=404b99bd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404b99bd"]])

export default __exports__